import Menu from 'components/Menu';
import RoundyContainer from 'components/RoundyContainer';
import ChangeHouseholdConfirm_Main from 'components/StraightThroughHouseholdComp/2_Confirm/ChangeHouseholdConfirm_Main';
import { HouseholdChangeContext, HouseholdChangeContextComp } from 'components/StraightThroughHouseholdComp/HouseholdContext/HouseholdChangeContext';
import HouseholdProgressBreadCrumb from 'components/StraightThroughHouseholdComp/HouseholdProgressBar/HouseholdProgressBreadCrumb';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { storageData } from 'services/Services';

const HouseholdConfirm = (props) => {
    const navigate = useNavigate()
    const { userData } = props.user
    const [showModal, setShowModal] = useState(true);
    const websiteMaintenance = JSON.parse(storageData?.getItem("websiteMaintenance"));

    const handleClose = () => {
        setShowModal(false);
        userData["disclosureModal"] = true
        storageData.setItem("userData", JSON.stringify(userData));
    }

    useEffect(() => {
        window.scrollTo(0, 0)

        // Redirect to maintenance page if maintenance is on for COA Endorsement
        if (websiteMaintenance?.status?.Result == "Active" && websiteMaintenance?.status?.Pages?.includes("EndorsementHousehold")) {
            navigate("/maintenance")
            return
        }
    }, [])

    return (
        <>
            <HouseholdChangeContextComp>
                <Menu Title={props.isHousehold?"UPDATE HOUSEHOLD":"ADDRESS CHANGE"} FirstName={userData.firstName} userData={userData} />
                <HouseholdProgressBreadCrumb requestContext={HouseholdChangeContext} screen={"Confirm"} />
                <RoundyContainer
                    Content={ChangeHouseholdConfirm_Main}
                    NoRoundy
                />
            </HouseholdChangeContextComp>
        </>
    )
}

export default HouseholdConfirm